<script>
import axios from 'axios'
import {Listeners} from "../../../constants/listeners";
import AdaptersDialog from "../../../component/adapters/Dialog.vue";
import Button from 'primevue/button';
import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';
import InputText from 'primevue/inputtext';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Divider from 'primevue/divider';
import TemplatesLabelCounts from '../../../templates/LabelCounts.vue';
import {FormatHelper} from "../../../helpers/FormatHelper";
import {UploadConstants} from "../../../constants/uploadConstants";
import debounce from 'lodash/debounce'

export default {
    name: "CreateCluster",
    data() {
        return {
            loading: false,
            projectName: "",
            groupReports: [],
            groupReport: "",
            filter: "",
            list: null,
            error: [],
            maxSize: UploadConstants.MAX_UPLOAD_SIZE,
            allowExtensions: UploadConstants.ALLOW_IMPORT_FILE_EXTENSIONS,
            limit: 100000,
            model: {},
            parsedLines: [],
            columnConfig: {},
            locale: window.locale
        }
    },
    props: {
        base: {
            type: String,
            required: true,
        },
        isDemo: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    created: function () {
        let self = this;
        this.$upload.on(this.key, {
            startOnSelect: false,
            extensions: self.allowExtensions,
            maxSizePerFile: self.maxSize,
            url: this.getApiUrl,
            http: (data) => {
                data.body.append('name', self.projectName);
                data.body.append('rid', self.groupReport);
                data.body.append('list', self.getTextAreaData);
                data.body.append('base', self.base);
                data.body.append('context', self.model.context);
                data.body.append('organic', self.model.organic);
                data.body.append('format', self.model.format);
                data.body.append('skipFirstLine', self.model.skipFirstLine);
                data.body.append('useKeysData', self.model.useKeysData);

                let columnConfig = {};
                for (let column in this.columnConfig) {
                    if (this.columnConfig[column] !== "skip") {
                        columnConfig[this.columnConfig[column]] = column;
                    }
                }

                data.body.append('columnConfig', JSON.stringify(columnConfig));

                self.loading = true;
                axios({
                    method: 'post',
                    url: data.url,
                    withCredentials: true,
                    data: data.body,
                }).then(data.success, data.error)

            },
            parseErrors(res) {
                return [{code: 'fileError', msg: res.response.data.message}];
            },
            onSuccess(file, response) {
                self.loading = false;
                window.location.href = "/" + window.locale + "/clustering-list/" + response.data.uid;
            },
            onError(error, instance) {
                self.loading = false;
                self.error = [];

                if (error && instance) {
                    self.error.push(instance.response.data.message);
                    return;
                }

                self.checkError();
            },
            onSelect(data) {
                self.columnConfig = [];
                self.parsedLines = [];

                let fileType = data[0].type;

                if (fileType === "application/vnd.ms-excel" || fileType === "text/csv") {
                    self.model.format = "csv";
                } else if (fileType === "text/plain") {
                    self.model.format = "txt";
                }

                if (self.model.format === 'txt') {
                    return false;
                }

                let reader = new FileReader();
                reader.onload = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        let result = decodeURIComponent(escape(window.atob(evt.target.result.split(",")[1])));
                        self.parsedLines = self.csvToArray(result).slice(0, 3);
                        if (self.parsedLines.length) {
                            let i = 0;
                            let more = [];
                            self.parsedLines[0].forEach(line => {
                                if (i === 0) {
                                    self.columnConfig[i] = "word";
                                } else {
                                    self.columnConfig[i] = "skip";
                                }

                                if (line.charCodeAt(0) === 0xFEFF) {
                                    line = line.substr(1);
                                }

                                if (line && line.toLowerCase() === self.$t('lang.cluster.cc_key')) {
                                    self.columnConfig[i] = "word";
                                }
                                if (line && line.toLowerCase() === self.$t('lang.cluster.cc_ws')) {
                                    self.columnConfig[i] = "ws";
                                }
                                if (line && line.toLowerCase() === self.$t('lang.cluster.cc_wsk')) {
                                    self.columnConfig[i] = "wsk";
                                }
                                if (line && line.toLowerCase() === self.$t('lang.cluster.cc_superwsk')) {
                                    self.columnConfig[i] = "superwsk";
                                }

                                i++;
                                more.push("...")
                            });
                            self.parsedLines.push(more);
                        }
                    }
                };
                reader.readAsDataURL(data[0]);

            },
        });

    },
    methods: {
        uploadData() {
            this.$upload.start(this.key);
        },
        insertData() {
            let self = this;
            self.loading = true;

            axios({
                method: 'post',
                url: this.getApiUrl,
                withCredentials: true,
                data: {
                    name: this.projectName,
                    rid: this.groupReport,
                    list: this.getTextAreaData,
                    context: this.model.context,
                    organic: this.model.organic,
                    base: this.base
                }
            })
            .then(response => window.location.href = sprintf("/%s/clustering-list/%s", window.locale, response.data.uid))
            .catch(error => self.error.push(error.response.data.message))
            .finally(() => self.loading = false);
        },
        save() {
            this.checkError();

            if (this.error.length > 0) {
                return false;
            }

            if (this.$upload.files(this.key).queue.length > 0) {
                this.uploadData();
            } else {
                this.insertData();
            }
        },
        checkError() {
            this.error = [];

            if (this.$upload.files(this.key).error.length) {
                switch (this.$upload.files(this.key).error[0].error.code) {
                    case "file-max-size":
                        this.error.push(this.$t('lang.cluster.file_size_err', [FormatHelper.number(this.maxSize)]));
                        break;
                    case "file-extension":
                        this.error.push(this.$t('lang.cluster.file_type_err', [this.allowExtensions.join(", ")]));
                        break;
                    default:
                        this.error.push(this.$upload.files(this.key).error[0].error.msg);
                }

                return false;
            }

            if (this.getTextAreaData.length > this.limit) {
                this.error.push(this.$t('lang.cluster.limit_count_err', [this.limit]));
            }

            if (this.$upload.files(this.key).queue.length === 0 && this.groupReport === "" && this.getTextAreaData.length === 0) {
                this.error.push(this.$t('lang.cluster.import_type_err'));
            }

            if (this.groupReport !== "" && !this.model.context && !this.model.organic) {
                this.error.push(this.$t('lang.cluster.import_grp_err'));
            }

            let result = {};

            if (this.model.format === 'csv') {
                for (let column in this.columnConfig) {
                    if (this.columnConfig[column] !== "skip") {
                        result[this.columnConfig[column]] = column;
                    }
                }

                if (!Object.keys(result).length) {
                    this.error.push(this.$t('lang.cluster.import_file_one_col_err'));
                    return false;
                }

                if (!result.hasOwnProperty("word")) {
                    this.error.push(this.$t('lang.cluster.import_file_col_err'));
                }

            }

        },
        onFilterChange: debounce(function (e) {
            this.filter = e.value;
            this.loadGroupReports()
        }, 1000),
        loadGroupReports() {
            let self = this;
            self.loading = true;
            axios({
                method: 'get',
                url: this.getGroupApiUrl,
                withCredentials: true
            })
                .then(function (response) {
                    self.loading = false;
                    self.groupReports = response.data.data;
                })
                .catch(function (error) {
                    self.loading = false;
                    self.error.push(error.response.data.message);
                });

        },
        closed() {
            this.$upload.reset(this.key);
            this.groupReport = "";
        },
        opened() {
            if (!this.isDemo) {
                this.loadGroupReports();
            }
            this.projectName = "";
            this.list = null;
            this.error = [];
            this.model = {
                organic: true,
                context: true,
                format: 'txt',
                skipFirstLine: true,
                useKeysData: false
            };
        },
        csvToArray(text) {
            let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
            for (l of text) {
                if ('"' === l) {
                    if (s && l === p) row[i] += l;
                    s = !s;
                } else if (';' === l && s) l = row[++i] = '';
                else if ('\n' === l && s) {
                    if ('\r' === p) row[i] = row[i].slice(0, -1);
                    row = ret[++r] = [l = ''];
                    i = 0;
                } else row[i] += l;
                p = l;
            }
            return ret;
        },
        onColumnConfigChange(event, index) {
            let value = event.target.value;

            for (let column in this.columnConfig) {
                if (index != column && this.columnConfig[column] !== "skip" && this.columnConfig[column] === value) {
                    this.columnConfig[column] = "skip";
                }
            }

            this.columnConfig[index] = value;
        },
        onShowPopupCreate() {
            this.opened();
            this.$emitter.emit(this.getListenerId);
        },
        onClosePopupCreate() {
            this.closed();
        },
        onHelp() {
            window.open('//help.keys.so/spravka-po-instrumentu-semanticheskie-yadra', '_blank');
        },
        onClickButtonAction() {
            this.$upload.reset(this.key);
            this.$upload.select(this.key);
        },
    },
    mounted() {
        if (window.location.hash !== "") {
            const hashs = window.location.hash.slice(window.location.hash.indexOf('#') + 1).split('&');

            if (hashs.length === 2 && hashs[0] === "from=gkeywords" && hashs[1].split("=").length === 2 && hashs[1].split("=")[1]) {
                this.groupReport = hashs[1].split("=")[1];
                this.onShowPopupCreate();
            }
        }
    },
    computed: {
        getApiUrl() {
            return this.$config.API_URL + '/clustering';
        },
        getGroupApiUrl() {
            let filter = 'state=10^base=' + this.base;
            if (this.groupReport) {
                filter += '^ORrid=' + this.groupReport;
            }
            if (this.filter) {
                filter += '^nameLIKE' + this.filter;
            }
            return this.$config.API_URL + '/report/group/list?sort=' + encodeURIComponent('access_date|desc') + '&filter=' + encodeURIComponent(filter);
        },

        getTextAreaData() {
            if (this.list) {
                return this.list.replace(/\r\n/g, "\n").split("\n").filter(item => {
                    return item != ""
                });
            }
            return [];
        },
        count() {
            return this.getTextAreaData.length;
        },
        key() {
            return 'key_create_cluster';
        },
        isCsv() {
            return this.parsedLines.length > 0 && this.model.format === 'csv';
        },
        getListenerId() {
            return Listeners.CLUSTER_POPUP_CREATE_OPEN;
        },

        getGroupReportsWithFullTitles() {
            let self = this;

            return this.groupReports.map(item => {
                let baseCaption = self.$tm('lang.main.bases').filter(
                    itemBase => itemBase.name === item.base
                )[0].caption;
                let title = (item.name ?? self.$t('lang.cluster.no_project_name')) + ' ' + baseCaption;

                if (item.owner) {
                    title += ' (' + item.owner + ')';
                }

                item.title = title;

                return item;
            });
        },
    },
    components: {
        AdaptersDialog,
        Button,
        InputText,
        Checkbox,
        Textarea,
        TabView,
        TabPanel,
        AdaptersDropdown,
        Divider,
        TemplatesLabelCounts,
    },
}
</script>
<template>
    <div>
        <Button :label="$t('lang.cluster.create_btn')" @click="onShowPopupCreate" icon="pi pi-plus" size="small" />

        <AdaptersDialog
            :header="$t('lang.cluster.modal_header')"
            :listener-id="getListenerId"
            :callback-on-hide="onClosePopupCreate"
            :loading="!groupReport && loading"
            :error-message="error.length > 0 ? error.join('<br/>') : null"
            :button-agree-label="$t('lang.main.btn.create')"
            :callback-agree="save"
            :button-additional-label="$t('lang.main.btn.help')"
            :callback-additional="onHelp"
        >
            <template #content>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label for="clusterProjectName">{{ $t('lang.cluster.project_name') }}</label>
                            <InputText
                                id="clusterProjectName"
                                v-model="projectName"
                                :placeholder="$t('lang.cluster.create_name_helper')"
                                maxlength="64"
                                ref="modalNameInput"
                            />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <label>{{ $t('lang.cluster.keywords') }}:</label>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="card">
                            <TabView>
                                <TabPanel v-if="!isDemo" :header="$t('lang.cluster.cls_from_grp_report').capitalize()">
                                    <div class="grid">
                                        <div class="col">
                                            <AdaptersDropdown
                                                v-model="groupReport"
                                                :options="getGroupReportsWithFullTitles"
                                                option-label="title"
                                                option-value="rid"
                                                class="w-full"
                                                :placeholder="$t('lang.cluster.choose_report')"
                                                :filter="true"
                                                @filter="onFilterChange"
                                                :pt="{
                                                    filterinput: {class: 'w-full'}
                                                }"
                                            />
                                        </div>
                                    </div>
                                    <div class="grid">
                                        <div class="col">
                                            <div class="formgroup-inline">
                                                <div class="field-checkbox">
                                                    <Checkbox v-model="model.organic" :binary="true" inputId="organic" />
                                                    <label for="organic">{{ $t('lang.cluster.import_organic') }}</label>
                                                </div>
                                                <div class="field-checkbox">
                                                    <Checkbox v-model="model.context" :binary="true" inputId="context" />
                                                    <label for="context">{{ $t('lang.cluster.import_context') }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col text-right">
                                            <a href="/group" target="_blank">{{ $t('lang.cluster.or_create_group') }}</a>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel :header="$t('lang.cluster.cls_from_file').capitalize()">
                                    <div class="grid">
                                        <div class="col">
                                            <p>
                                                {{ $t('lang.cluster.txt_import_helper') }}
                                                <a :href="'/resources/' + locale + '/sample.txt'" target="_blank">
                                                    {{ $t('lang.cluster.select_file_example') }}
                                                </a>
                                            </p>
                                            <p>
                                                {{ $t('lang.cluster.csv_import_helper') }}
                                                <a :href="'/resources/' + locale + '/sample.csv?1'" target="_blank">
                                                    {{ $t('lang.cluster.select_file_example') }}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="ks-alert alert alert-info">
                                        <i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp
                                        <span v-html="$t('lang.cluster.file_import_code')"></span>
                                    </div>
                                    <div class="grid">
                                        <div class="col">
                                            <Button
                                                @click="onClickButtonAction"
                                                :disabled="$upload.meta(key).status === 'sending' || $upload.meta(key).status === 'complete'"
                                                :label="$upload.meta(key).status === 'sending' ? $t('lang.main.btn.loading') : $t('lang.main.btn.choose') + '...'"
                                                size="small"
                                            />
                                            <span
                                                v-for="file in $upload.files(key).all"
                                                class="info"
                                                style='text-align: left; display: block;'
                                            >
                                                {{ file.name }}
                                            </span>
                                        </div>
                                    </div>
                                    <template v-if="isCsv">
                                        <div class="grid">
                                            <div class="col">
                                                <Divider />
                                            </div>
                                        </div>
                                        <div class="grid">
                                            <div class="col">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="cnt-config tablereports">
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <td v-for="(cell, index) in parsedLines[0]">
                                                                            <select
                                                                                v-model="columnConfig[index]"
                                                                                @change="onColumnConfigChange($event, index)"
                                                                            >
                                                                                <option value="word">{{ $t('lang.cluster.vv_key') }}</option>
                                                                                <option value="ws">{{ $t('lang.cluster.vv_ws') }}</option>
                                                                                <option value="wsk">{{ $t('lang.cluster.vv_wsk') }}</option>
                                                                                <option value="superwsk">{{ $t('lang.cluster.vv_superwsk') }}</option>
                                                                                <option value="skip">{{ $t('lang.cluster.vv_skip') }}</option>
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="line in parsedLines">
                                                                        <td v-for="cell in line">{{ cell }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <label class="radio">
                                                            <input
                                                                type="checkbox"
                                                                v-model="model.skipFirstLine"
                                                                name="skipFirstLine"
                                                            />
                                                            {{ $t('lang.cluster.skip_f_line') }}
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-12" v-if="!isDemo">
                                                        <label class="radio">
                                                            <input
                                                                type="checkbox"
                                                                v-model="model.useKeysData"
                                                                name="useKeysData"
                                                            />
                                                            {{ $t('lang.cluster.use_our_data') }}
                                                            <a
                                                                href
                                                                class="help-link"
                                                                :title="$t('lang.cluster.use_our_data_help')"
                                                            >
                                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                            </a>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </TabPanel>
                                <TabPanel :header="$t('lang.cluster.cls_from_area_1').capitalize()">
                                    <div class="formgrid grid">
                                        <div class="field col">
                                            <TemplatesLabelCounts
                                                :text="$t('lang.cluster.keys_list_rules')"
                                                :count="count"
                                                :limit="limit"
                                            />
                                            <Textarea v-model="list" rows="6" id="result" />
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </AdaptersDialog>
    </div>

</template>
<style scoped>
:deep(.p-button) .pi {
    font-size: 0.8125rem;
}
p {
    line-height: 20px;
}

.cnt-config {
    width: auto;
    overflow: auto;
}

.cnt-config select {
    width: 134px;
}

main {
    margin: 0 auto;
    background: #fff;
}

main section {
    display: none;
    padding: 20px 0 0;
    border-top: 1px solid #ddd;
}

main input:not([type='checkbox']) {
    display: none;
}

main label.tab-label {
    display: inline-block;
    margin: 0 0 -1px;
    padding: 5px 15px;
    font-weight: 600;
    text-align: center;
    color: #bbb;
    border: 1px solid transparent;
}

main label.tab-label:before {
    font-family: fontawesome;
    font-weight: normal;
    margin-right: 10px;
}

main label.tab-label:hover {
    color: #888;
    cursor: pointer;
}

main input:checked + label.tab-label {
    color: #555;
    border: 1px solid #ddd;
    border-top: 2px solid #68aa13;
    border-bottom: 1px solid #fff;
}

main select {
    width: 100%;
}

.radio {
    display: inline;
    padding-right: 10px;
}

.radio-file {
    display: inline-block;
    width: 100%;
    margin: 0px;
}

.radio-file input {
    display: inline-block !important;
}

#tab1:checked ~ #content1,
#tab2:checked ~ #content2,
#tab3:checked ~ #content3 {
    display: block;
}
</style>
